import { EnhancedEncryption, FilterAlt, FolderShared, InsertChart, ListAlt } from '@mui/icons-material';
import SvgIcon from '@mui/material/SvgIcon/SvgIcon';
import { Screen } from './screens';

export interface SideBarItem {
    screen: Screen;
    Icon: typeof SvgIcon;
}

export const mainMenuItems: SideBarItem[] = [
    {
        Icon: InsertChart,
        screen: Screen.Dashboard,
    },
    {
        Icon: FilterAlt,
        screen: Screen.Operations,
    },
    {
        Icon: EnhancedEncryption,
        screen: Screen.UserAccess,
    },
    // {
    //     Icon: AddTask,
    //     screen: Screen.CreateTask,
    // },
    {
        Icon: ListAlt,
        screen: Screen.ManualTaskV2,
    },
    {
        Icon: FolderShared,
        screen: Screen.GenerateReport,
    },
];
